export default __webpack_public_path__ + "static/media/logo.4d6e7b72.png";